import {useEffect, useState} from 'react'
import DialogIndex from '@mui/material/Dialog'
import DrawerIndex from '@mui/material/Drawer';

export function Dialog({
    onChange = () => {},
    value = false,
    children,
    switchElement
}) {
    const [open, setOpen] = useState(value)
    const switchOpen = () => {
        setOpen(v => {
            const _v = !v
            onChange(_v)
            return _v
        })
    }
    
    useEffect(() => {
        setOpen(value)
    }, [value])
    
    return (
        <>
            {
                switchElement && switchElement({ onClick: switchOpen })
            }
            <DialogIndex onClose={switchOpen} open={open}>
                {children}
            </DialogIndex>
        </>
    )
}


export function Drawer({
    onChange = () => {},
    value = false,
    children,
    switchElement,
    ...prop
}) {
    const [open, setOpen] = useState(value)
    const switchOpen = () => {
        setOpen(v => {
            const _v = !v
            onChange(_v)
            return _v
        })
        
    }
    
    useEffect(() => {
        setOpen(value)
    }, [value])
    
    return (
        <>
            {
                switchElement && switchElement({ onClick: switchOpen })
            }
            <DrawerIndex onClose={switchOpen} open={open} {...prop}>
                {children}
            </DrawerIndex>
        </>
    )
}